import {createAction, handleActions} from 'redux-actions';
import {Api} from '../../api/api';
import {fetchSubmitForm, fetchSubmitFormFailed, fetchSubmitFormSuccess} from '../common/submitForm';
import { logout, onForbidden } from '../account/login';
import _ from 'lodash';
import {getCurrentStatus, getRequestsByStatus, getCurrentPageForConsents, incrementNumberOfProcessedConsents} from "./consents";
import {hideModal} from "../common/activeModal";

//- Actions
export const fetchGetConsentByIdFailed = createAction('FETCH_GET_CONSENT_BY_ID_FAILED');
export const fetchGetConsentByIdSuccess = createAction('FETCH_GET_CONSENT_BY_ID_SUCCESS');
export const fetchGetConsentById = createAction(
    'FETCH_GET_CONSENT_BY_ID',
    (id) => Api.getConsentById(id),
    () => ({
        apiCall: true,
        onSuccess: fetchGetConsentByIdSuccess,
        onFail: fetchGetConsentByIdFailed,
        onUnauthorized: logout,
        onForbidden: onForbidden
    })
);

export const fetchUpdateConsent = (id, data) => dispatch => {
    dispatch(fetchSubmitForm());
    dispatch(onUpdateConsent(id, data));
};

export const fetchUpdateConsentSuccess = () => (dispatch, getState) => {
    let currentStatus = getCurrentStatus(getState());
    let currentPage = getCurrentPageForConsents(getState());
    dispatch(getRequestsByStatus(currentStatus, currentPage));
    dispatch(fetchSubmitFormSuccess());
    dispatch(incrementNumberOfProcessedConsents());
    dispatch(hideModal());
};

export const onUpdateConsent = createAction(
    'FETCH_GRANT_REQUEST',
    (id, data) => Api.updateConsent(id, data),
    () => ({
        apiCall: true,
        onSuccess: fetchUpdateConsentSuccess,
        onFail: fetchSubmitFormFailed,
        onUnauthorized: logout,
        onForbidden: onForbidden
    })
);

//- State
const initialState = {
    data: null,
    error: null,
    fetching: false
};

//- Reducers
export default handleActions({
    FETCH_GET_CONSENT_BY_ID: (state) => {
        return {...state, data: null, error: null, fetching: true};
    },
    FETCH_GET_CONSENT_BY_ID_FAILED: (state, action) => {
        return {...state, data: null, error: action.payload, fetching: false};
    },
    FETCH_GET_CONSENT_BY_ID_SUCCESS: (state, action) => {
        return {...state, data: action.payload, error: null, fetching: false};
    }
}, initialState);

//- Selectors
export const getConsent = state => state.consent;

export const loadingConsent = state => getConsent(state).fetching;

export const getConsentData = state => getConsent(state).data;

export const getFormattedConsent = state => {
    let data = getConsentData(state);

    if (_.isNil(data)) {
        return null;
    }

    return {
        id: data.id,
        email: data.contactEmail,
        firstName: data.requester ? data.requester.identityAlias.firstName : null,
        lastName: data.requester ? data.requester.identityAlias.lastName : null,
        companyName: data.organization.name,
        message: data.requestComment,
        companyCountry: data.organization.address.countryCode,
        job: data.jobDescription.internalReference ? data.jobDescription.internalReference + " - " + data.jobDescription.title : data.jobDescription.title,
        requestDate: data.createdAt
    };
};



// WEBPACK FOOTER //
// ./src/reducers/consent/consent.js